import {
  CohortBuilderDefinitionLegacy,
  SubjectVariableCriteriaSelectionTypeLegacy,
} from '@verantos-dev/types-cohorts';
import { parseCohortDefinitionQuery } from '@verantos-dev/util-cohort-builder-typescript-runtime';
import { getFullDslQueryString } from '@verantos-dev/util-cohort-definition-ui-to-dsl';

import { validateForDuplicateNames } from './cohort-definition-validation/validateForDuplicateNames';

/**
 * This function will validate the current cohort definition and determine whether it is valid for processing.
 *
 * @param {CohortBuilderDefinition} cohortDefinition - the current cohort builder definition to validate
 * @returns {boolean} - true if the cohort definition is valid for processing, false otherwise
 */
export const validateCohortDefinitionForProcessing = ({
  cohortDsl,
  subjectVariables,
  derivedEvents,
  simpleEvents,
}: CohortBuilderDefinitionLegacy): boolean => {
  /** verify that at least one inclusion criteria exists, which also infers that a subject variable exists */
  const hasInclusionCriteria = subjectVariables.some((variable) => {
    return variable.criteriaSelection === SubjectVariableCriteriaSelectionTypeLegacy.INCLUSION;
  });

  /** verify that query has no errors */
  const { customErrorListener } = parseCohortDefinitionQuery(getFullDslQueryString(cohortDsl));
  const hasQueryErrors = customErrorListener.errors.length > 0;

  /** Verify no duplicate names exist */
  const { hasDuplicateName } = validateForDuplicateNames(
    subjectVariables,
    derivedEvents,
    simpleEvents
  );

  // Return true if all validations pass, if any validation is true, then we can consider this cohort definition invalid and return false
  return hasInclusionCriteria && !(hasQueryErrors || hasDuplicateName);
};
